import './styles.css';

/**
 * Animated "..." typing indicator. Renders three dots with staggered opacity
 * animation. Extracted from the main app's `components/loader/loader.comp.tsx`.
 */
export function DotsTyping() {
  // role="status" makes this a polite live region so a screen reader announces
  // that a response is on its way (WCAG 4.1.3); the visual dots themselves are
  // decorative, so the accessible name comes from aria-label, not their text.
  return (
    <span
      className="cs-dots-typing"
      role="status"
      aria-label="Assistant is typing"
    >
      <span className="cs-dots-typing-item" aria-hidden="true">
        .
      </span>
      <span className="cs-dots-typing-item" aria-hidden="true">
        .
      </span>
      <span className="cs-dots-typing-item" aria-hidden="true">
        .
      </span>
    </span>
  );
}
